
import { defineComponent, PropType } from "vue";
// components
import ScheduleDeleteButton from "@/features/schedules/ScheduleDeleteButton.vue";
import TableRowMenu from "@/components/table/TableRowMenu.vue";
import TableRowMenuItem from "@/components/table/TableRowMenuItem.vue";
// other
import { Schedule } from "@/graphql/types";
import { cleanUuid } from "@/utils/globalHelpers";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "ScheduleTableItemMenu",
  components: {
    ScheduleDeleteButton,
    TableRowMenu,
    TableRowMenuItem
  },
  props: {
    schedule: { type: Object as PropType<Schedule>, required: true }
  },
  setup(props) {
    // navigation
    const router = useRouter();

    // click edit
    const onEdit = () => {
      const scheduleId = cleanUuid(props.schedule.id);
      router.push({ path: `/schedules/${scheduleId}` });
    };

    return { onEdit };
  }
});
